import { render, staticRenderFns } from "./Plugin.vue?vue&type=template&id=15e3bff3&scoped=true&"
import script from "./Plugin.vue?vue&type=script&lang=js&"
export * from "./Plugin.vue?vue&type=script&lang=js&"
import style0 from "./Plugin.vue?vue&type=style&index=0&id=15e3bff3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e3bff3",
  null
  
)

export default component.exports